import { Card } from "PFComponents/card";
import { LoadingSpinner } from "PFComponents/loading_spinner";
import { TableData } from "PFComponents/table/table";
import { GenerateColumnsFn } from "PFComponents/table/table.types";
import { Import, ImportBase, PaginatedCollection } from "PFTypes";
import { Dispatch, SetStateAction } from "react";

import { ImportDataTable } from "./import_data_table";
import { ImportDataTableCounters, ImportDataTableCountersProps } from "./import_data_table_counters";
import { ImportDataTableHeader, ImportDataTableHeaderProps } from "./import_data_table_header";
import css from "./import_data_table_page.module.scss";

type ImportDataTablePageProps<IMPORT_ROW extends TableData, T extends ImportBase = Import> = {
  importData: T;
  counters: ImportDataTableCountersProps["counters"];
  isLoading: boolean;
  data?: PaginatedCollection<IMPORT_ROW[]>;
  selectedCounter: string;
  onSelectedCounterChange: Dispatch<SetStateAction<string>>;
  currentPage: number;
  onCurrentPageChange: (number: number) => void;
  generateColumns: GenerateColumnsFn<IMPORT_ROW>;
  fetchImportDocs?: ImportDataTableHeaderProps<T>["fetchImportDocs"];
};

export const ImportDataTablePage = <IMPORT_ROW extends TableData, T extends ImportBase = Import>({
  importData,
  counters,
  isLoading,
  data,
  currentPage,
  onCurrentPageChange,
  selectedCounter,
  onSelectedCounterChange,
  generateColumns,
  fetchImportDocs
}: ImportDataTablePageProps<IMPORT_ROW, T>) => {
  const handleCounterChange = (counter: ImportDataTableCountersProps["counters"][0]["code"]) => {
    onCurrentPageChange(1);
    onSelectedCounterChange(counter);
  };

  return (
    <div className={css.root}>
      <ImportDataTableHeader<T> fetchImportDocs={fetchImportDocs} importData={importData} />
      <Card shadowVariant="inset" paddingVariant="xl" className={css.card}>
        <ImportDataTableCounters
          counters={counters}
          selectedCounter={selectedCounter}
          onCounterChange={handleCounterChange}
        />
        {isLoading || !data ? (
          <div className={css.loading}>
            <LoadingSpinner />
          </div>
        ) : (
          <ImportDataTable<IMPORT_ROW>
            rowsData={data}
            setCurrentPage={onCurrentPageChange}
            currentPage={currentPage}
            generateColumns={generateColumns}
          />
        )}
      </Card>
    </div>
  );
};
